import { render, staticRenderFns } from "./PricingTemplatesSection.vue?vue&type=template&id=73b57756&scoped=true&"
import script from "./PricingTemplatesSection.vue?vue&type=script&lang=js&"
export * from "./PricingTemplatesSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingTemplatesSection.vue?vue&type=style&index=0&id=73b57756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b57756",
  null
  
)

export default component.exports